var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDisabled && !_vm.isSecondary)?_c('WaterDropIcon',{attrs:{"isLeakage":_vm.isLeakage}}):_c('button',{style:({
    width: _vm.width + 'px',
    height: _vm.height + 'px',
    backgroundColor: _vm.hover && !_vm.isSecondary ? (_vm.isLeakage ? '#ffeff0' : '#f0f0f0') : '#fafafa',
    border: '1px solid ' + (
      _vm.isLeakage
        ? (_vm.isSecondary ? '#9a9a9a' : (_vm.hover && !_vm.isSecondary ? '#b80008' : '#E10009'))
        : (_vm.hover && !_vm.isSecondary ? '#999999' : '#cccccc')
    ),
    borderRadius: '8px',
    cursor:  _vm.isSecondary ? 'no-drop' : 'pointer',
    transition: 'background 0.15s ease-in-out, border 0.15s ease-in-out, color 0.15s ease-in-out',
    color: _vm.isSecondary ? (this.isSecondary ? '#9a9a9a' : '#E10009') : '#fff',
  }),on:{"click":_vm.handleSubmitLeakage,"mouseenter":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false}}},[(_vm.hover && !_vm.isDisabled && _vm.isSecondary)?_c('div',[_c('WaterDropIcon',{attrs:{"isLeakage":true}})],1):_c('div',[_c('WaterDropIcon',{attrs:{"isLeakage":_vm.isLeakage}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }